// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stakingRisk_trash_stakingRisk__sI4nD {
    background: #F0F0F3;
    transition: background-color 0.3s ease;
    /* height: 380px;
    max-width: 240px ; */

}

.stakingRisk_trash_stakingRisk__sI4nD .stakingRisk_trash_staking_card_product_scroller__FMjb->div:nth-child(odd) {
    background: #8484840D;

}

.stakingRisk_trash_staking_card_product_title__8A07w {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-left: 10px;
    width: 130px;
    color: #364048;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stakingRisk_trash_staking_card_product_level__5BYv8 {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-right: 10px;
    text-align: right;
    color: #4DC7B5;
    white-space: nowrap;
}

.stakingRisk_trash_double_arrow__AI2nK {
    background-color: #F0F0F3;
    width: 24px;
    height: 24px;
    border-radius: 30px;
    box-shadow: 3px 3px 8px 0px #AEAEC066;
    margin: 0 auto;
    text-align: center;
    line-height: 30px;
    display: none;
    position: absolute;
    bottom: -15px;
    left: 0;
    right: 0;
    cursor: pointer;
    transition: transform 0.5s ease;
    z-index: 10;
}

.stakingRisk_trash_stakingRisk__sI4nD:hover, .stakingRisk_trash_stakingRisk__sI4nD:hover .stakingRisk_trash_double_arrow__AI2nK {
    display: block;
    background: #FDFDFD;
}

.stakingRisk_trash_staking_card_product_scroller__FMjb- {
    height: 98px;
    border-radius: 16px;
    box-shadow: -5px -5px 5px 0px rgba(255, 255, 255, 0.7490196078) inset, 5px 5px 5px 0px rgba(174, 174, 192, 0.2) inset;
    width: 100%;
    overflow-y: hidden;
    transition: height 0.5s ease;
}

.stakingRisk_trash_staking_card_product_scroller__FMjb-.stakingRisk_trash_expanded__xyg5H {
    height: 250px;
    position: absolute;
    top: 0;
    z-index: 10;
    background: #f0f0f3;
    overflow: auto;
}

.stakingRisk_trash_double_arrow__AI2nK.stakingRisk_trash_rotate__jjv-D {
    transform: rotate(180deg);
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Main/Trash/Component/StakingRiskTrash/stakingRisk_trash.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sCAAsC;IACtC;wBACoB;;AAExB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,eAAe;IACf,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,qHAAqH;IACrH,WAAW;IACX,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".stakingRisk {\n    background: #F0F0F3;\n    transition: background-color 0.3s ease;\n    /* height: 380px;\n    max-width: 240px ; */\n\n}\n\n.stakingRisk .staking_card_product_scroller>div:nth-child(odd) {\n    background: #8484840D;\n\n}\n\n.staking_card_product_title {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-left: 10px;\n    width: 130px;\n    color: #364048;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.staking_card_product_level {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-right: 10px;\n    text-align: right;\n    color: #4DC7B5;\n    white-space: nowrap;\n}\n\n.double_arrow {\n    background-color: #F0F0F3;\n    width: 24px;\n    height: 24px;\n    border-radius: 30px;\n    box-shadow: 3px 3px 8px 0px #AEAEC066;\n    margin: 0 auto;\n    text-align: center;\n    line-height: 30px;\n    display: none;\n    position: absolute;\n    bottom: -15px;\n    left: 0;\n    right: 0;\n    cursor: pointer;\n    transition: transform 0.5s ease;\n    z-index: 10;\n}\n\n.stakingRisk:hover, .stakingRisk:hover .double_arrow {\n    display: block;\n    background: #FDFDFD;\n}\n\n.staking_card_product_scroller {\n    height: 98px;\n    border-radius: 16px;\n    box-shadow: -5px -5px 5px 0px rgba(255, 255, 255, 0.7490196078) inset, 5px 5px 5px 0px rgba(174, 174, 192, 0.2) inset;\n    width: 100%;\n    overflow-y: hidden;\n    transition: height 0.5s ease;\n}\n\n.staking_card_product_scroller.expanded {\n    height: 250px;\n    position: absolute;\n    top: 0;\n    z-index: 10;\n    background: #f0f0f3;\n    overflow: auto;\n}\n\n.double_arrow.rotate {\n    transform: rotate(180deg);\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stakingRisk": `stakingRisk_trash_stakingRisk__sI4nD`,
	"staking_card_product_scroller": `stakingRisk_trash_staking_card_product_scroller__FMjb-`,
	"staking_card_product_title": `stakingRisk_trash_staking_card_product_title__8A07w`,
	"staking_card_product_level": `stakingRisk_trash_staking_card_product_level__5BYv8`,
	"double_arrow": `stakingRisk_trash_double_arrow__AI2nK`,
	"expanded": `stakingRisk_trash_expanded__xyg5H`,
	"rotate": `stakingRisk_trash_rotate__jjv-D`
};
export default ___CSS_LOADER_EXPORT___;
